import store from '../store';
import { check, currentUserGroup, getAuthorizationToken, isPseudoLoggedIn } from './tokenUtils';

const PSEUDO_RETAILER_GROUPS = ['owner', 'staff'];

function validSession() {
  const token = getAuthorizationToken();
  return Boolean(token) && check(token);
}

export function isRepLoggedIn() {
  const { viewConfig } = store.getState();

  if (!validSession() || !viewConfig.isRep || viewConfig.isAdmin) {
    return false;
  }

  return !(isPseudoLoggedIn() && PSEUDO_RETAILER_GROUPS.includes(currentUserGroup()));
}

export function isAdminLoggedIn() {
  return validSession() && store.getState().viewConfig.isAdmin;
}
